import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------
import {  useTranslation } from 'react-i18next';

export default function AppPieChart(props) {
//  const chartOptions = merge(BaseOptionChart(), );
  const {t} = useTranslation();
    var pieChartData = [44, 55, 13, 33];
    var total = 100;
    
    if (props.data != null) {
      pieChartData = props.data.map(p => p.data.map(i => i.y).reduce((a, b) => a + b, 0));
      total = pieChartData.reduce((a, b) => a + b, 0);
    }


    const chartOptions = {
    chart: {
      type: 'pie',
      stacked: true,
      height: 450,
      zoom: {
        enabled: false
      },
      toolbar: {
        show : true,
        autoSelected: 'zoom'
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
        enabled: true,
        formatter: function (val) {
            return val.toFixed(2) + "%";
        }
      },
    markers: {
      size: 0,
    },
    // stroke: {
    //   width: 2,
    //   curve: 'stepline'
    // },
    // fill: {
    //   type: 'gradient',
    //   gradient: {
    //     shadeIntensity: 1,
    //     inverseColors: false,
    //     opacityFrom: 1,
    //     opacityTo: 1,
    //     stops: [0, 90, 100]
    //   },
    // },

    tooltip: {
      shared: false,
      y: {
        formatter: function (val) {
          return val + " " + (val / total *100).toFixed(2) + "%";
        }
      }
    }
  };

    if (props.data == null){
        return <div></div>
    }


    chartOptions.labels =  props.data.map(p => p.name);
    //   [
    //     { x: new Date('2018-02-12').getTime(), y: 76 }, 
    //     { x: new Date('2018-02-15').getTime(), y: 22 },
    //     { x: new Date('2018-03-15').getTime(), y: 22 },
    //     { x: new Date('2018-03-15').getTime(), y: 0 },
    // ]

    // options = {
    //     series: [44, 55, 13, 33],
    //     labels: ['Apple', 'Mango', 'Orange', 'Watermelon']
    //   }



    // console.log(props.data.map(p => p.data.map(i => i.y).reduce((a, b) => a + b, 0)));
    // console.log(props.data.map(p => p.name));
    // console.log(props.data.map(p => p));
    return (
        <Box sx={{ p: 3, pb: 1, pt:0 }} dir="ltr">
        <   ReactApexChart type="pie" series={pieChartData} options={chartOptions} height={props.height} />
        </Box>
    );
}
